import { render, staticRenderFns } from "./ProjectImpactMilestonesTab.vue?vue&type=template&id=1af46ea3&scoped=true&"
import script from "./ProjectImpactMilestonesTab.vue?vue&type=script&lang=js&"
export * from "./ProjectImpactMilestonesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af46ea3",
  null
  
)

export default component.exports